import { ImageServiceV1Impl } from './v1';
import { ImageServiceV2Impl } from './v2';
export * from './v1/types';
export * from './v1/request';
export * from './v2/types';
export * from './v2/request';
export * from './types/config';
export * from './types/request';
export function defineImageService(config) {
    return {
        id: 'image-service',
        optionalDependencies: {
            featureServices: {
                's2:logger': '^1.0.0'
            }
        },
        create: env => {
            const logger = env.featureServices['s2:logger'];
            const srv = new ImageServiceV1Impl(config, logger || console);
            const srv2 = new ImageServiceV2Impl(config, logger || console);
            return {
                '1.1.1': () => ({
                    featureService: srv
                }),
                '2.0.0': () => ({
                    featureService: srv2
                })
            };
        }
    };
}
